var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7C6.25 5.76387 6.61656 4.5555 7.30331 3.52769C7.99007 2.49988 8.96619 1.6988 10.1082 1.22576C11.2503 0.752708 12.5069 0.628937 13.7193 0.870095C14.9317 1.11125 16.0453 1.70651 16.9194 2.58059C17.7935 3.45466 18.3888 4.56831 18.6299 5.78069C18.8711 6.99307 18.7473 8.24974 18.2742 9.39177C17.8012 10.5338 17.0001 11.5099 15.9723 12.1967C14.9445 12.8834 13.7361 13.25 12.5 13.25H5.625C4.46468 13.25 3.35188 12.7891 2.53141 11.9686C1.71094 11.1481 1.25 10.0353 1.25 8.875C1.25 7.71468 1.71094 6.60188 2.53141 5.78141C3.35188 4.96094 4.46468 4.5 5.625 4.5C5.99104 4.49987 6.35572 4.54447 6.71094 4.63281",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.5c2e5325.svg";
export { ForwardRef as ReactComponent };